/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import * as pagesActions from './Pages-Actions';
import * as pagesOperations from './Pages-Operations';

const pagesWatcherSagas = [
    ...pagesOperations.watchers,
];

export {
    pagesOperations,
    pagesActions,
    pagesWatcherSagas,
};
